import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {pipe, Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {Store} from '@ngrx/store';
import {DataSurveyState} from '../../../store/reducers/data-survey.reducers';
import {take, takeUntil} from 'rxjs/operators';
import {Guid} from 'guid-typescript';
import {Configuration} from '@shared/models/configuration';
import {DialogModel} from '@shared/models/dialog.model';
import {AddReportCommand} from '../../../commands/report.commands';
import { DeleteSurveyExecutionCommand, ArchiveReportCommand } from '../../../commands/survey.commands';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { SetActivityFeedAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';

@Component({
    standalone: false,
    selector: 'particle-report-content',
  templateUrl: './report-content.component.html',
  styleUrls: ['./report-content.component.scss']
})
export class ReportContentComponent implements OnInit, OnDestroy {

  sourceKey: string;
  isClose = false;
  breadcrumbs: BreadcrumbModel[];
  ngUnsubscribe: Subject<void> = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  showArchived: boolean;
  constructor(private router: Router,
    private dialogService: DialogService,
    private commandService: CommandService,
    private dataSurveyStore: Store<DataSurveyState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private activatedRoute: ActivatedRoute) {
    this.sourceKey = 'Generic-Report';
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview'
      },
      <BreadcrumbModel>{
        id : 'Reports',
        title: 'Reports',
        type: 'Reports',
        relativeUrl: 'dac6-reporter/reports'
      }
    ];
    this.invalidateSubject = new InvalidateSubject();
    this.showArchived = false;
  }

  ngOnInit() {
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['SHOW_ARCHIVED'] = this.showArchived;

    // const activityInfo = {type: 'Tool', 'id': 'generic-report', 'title': 'Reports', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }
  handleChange($event){
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['SHOW_ARCHIVED'] = this.showArchived;
    this.invalidateSubject.invalidate();
  }
  onGridCellValueChange($event) {
    console.log($event);
    if ($event.action) {
      switch ($event.action.id) {
        case 'AddTask':
          this.router.navigateByUrl(`dac6-reporter/reports/${$event.item.id}/add-task`);
          return;
        case 'ArchiveReport':
            const archiveCommand = new ArchiveReportCommand($event.item.id, true);
            this.commandService.executeCommand(archiveCommand).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
              this.invalidateSubject.invalidate();
            });
            break;
        case 'UnarchiveReport':
            const unarchiveCommand = new ArchiveReportCommand($event.item.id, false);
            this.commandService.executeCommand(unarchiveCommand).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
              this.invalidateSubject.invalidate();
            });
            break;
      }
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'Title' ) {
      this.router.navigateByUrl(`dac6-reporter/reports/${$event.item.id}`);
    }
  }
  addReport() {
    const dialogModel = DialogModel.create('Add Report', 'AddReportComponent',
      {title: '', description: ''}
      );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(state => {
      if (state.action === 'OK') {
        this.commandService.executeCommand(new AddReportCommand(state.data.input.title, state.data.input.description))
          .pipe(take(1)).subscribe(commandState => {
            console.log('AddReportCommand', commandState);
            this.router.navigateByUrl(`dac6-reporter/reports/${commandState.Payload.Id}/add-task`);
        });
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  close() {
    this.isClose = true;
  }
}
